<template>
	<div class="layout">
		<div class="container control-panel mt-2">
			<div class="row row-cols-2 row-cols-lg-2 g-2 justify-content-start align-items-center">
				<div v-if="accountStore.permissions.includes('manage_organizations')"
					class="col me-2"
					:style="{width: $options.buttonEdgeLen, height: $options.buttonEdgeLen,}"
				>
					<!-- Save graph layout button -->
					<button class="btn btn-sm btn-light btn-on-graph p-0 px-0 py-0"
						:style="{width: $options.buttonEdgeLen, height: $options.buttonEdgeLen,}"
						title="Зберегти положення станцій та КВП для всіх користувачів організації"
						@click.stop="save('layout')">
						<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16"
							height="16" viewBox="0 0 16 16" version="1.1" class="si-glyph si-glyph-satellite">
							<path d="M12 2h-2v3h2z" />
							<path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v13A1.5 1.5 0 0 0 1.5 16h13a1.5 1.5 0 0 0 1.5-1.5V2.914a1.5 1.5 0 0 0-.44-1.06L14.147.439A1.5 1.5 0 0 0 13.086 0zM4 6a1 1 0 0 1-1-1V1h10v4a1 1 0 0 1-1 1zM3 9h10a1 1 0 0 1 1 1v5H2v-5a1 1 0 0 1 1-1" />
						</svg>
					</button>
				</div>
				<!-- Search node input -->
				<div class="col-auto col-xs-10">
					<div class="input-group input-group-sm">
						<input
							v-model.trim="search"
							type="search"
							class="form-control"
							style="max-width: 15rem;"
							placeholder="Знайти СКЗ/КВП"
							list="list-nodes"
							@input="onSearchNodeInputChange"
						/>
						<datalist id="list-nodes">
							<option v-for="[key, node] in Object.entries(nodes)" :key="key" :value="key">
							{{ node.name.trim() }}
							</option>
						</datalist>
					</div>
				</div>
			</div>
		</div>

		<v-network-graph
			v-if="isLoaded"
			ref="graph"
			class="graph"
			:nodes="nodes"
			:edges="edges"
			:layouts="layout"
			v-model:zoom-level="zoomLevel"
			@update:layouts="newValue => layout = newValue"
			:event-handlers="eventHandlers"
			:configs="graphConfig"
		>
			<!-- Replace the node component -->
			<template #override-node="{ nodeId, scale, config, x, y, ...slotProps }">
				<!-- Object circle -->
				<circle :r="config.radius * scale * 1.2" :fill="nodes[nodeId].color" v-bind="slotProps" />
				<!-- Object icon inside circle -->
				<path
					fill="#f9f9fc"
					style="pointer-events: none" 
					:transform="`translate(-${8 * scale * 1.2},-${8 * scale * 1.2}) scale(${scale * 1.2})`"
					:d="nodeIconPath(nodes[nodeId].type)"
				/>
				<!-- Background for potential promt -->
				<rect :x="-26 * scale" :y="(6 + config.radius) * scale" :width="52 * scale" :height="16 * scale"
					:fill="potentialColor(nodes[nodeId].potential)" opacity="0.5"
					:transform="`translate(${x} ${y}) scale(${scale})`" :rx="4 * scale" :ry="4 * scale" />
				<!-- Potential promt -->
				<text x="0" :y="(10 + config.radius) * scale" :font-size="11 * scale" font-weight="600"
					text-anchor="middle" dominant-baseline="hanging"
					:transform="`translate(${x} ${y}) scale(${scale})`">
					E = {{ nodes[nodeId].potential }}<br>
				</text>
			</template>

			<template #edge-label="{ edge, ...slotProps }">
				<v-edge-label :text="edge.label" align="center" vertical-align="center" v-bind="slotProps" />
			</template>
		</v-network-graph>
	</div>

	<pop-up-modal v-model:show="edgePopUp.isShow" :title="edgePopUp.title">
		<template v-slot:body>
			<div class="row row-cols-1 row-cols-lg-2 g-4">
				<div v-for="node in [edgePopUp.sourceNode, edgePopUp.targetNode]" :key="node.object?.id" class="col">
					<div class="card h-100">
						<div class="card-header pe-auto btn btn-light" @click="goToNodeControlSection(node)">
							{{ node.object?.passport?.get(ObjectPrototype.passportKeys.name) }}
						</div>
						<div class="card-body">
							<p class="card-text">
								<b>Газопровід/Нафтопровід</b>:&nbsp;{{ dashIfUndefined(
								pipelines(objectOrg(node.object)).find(el => el.id ==
								node.object?.passport?.get(ObjectPrototype.passportKeys.pipelineId))?.title ) }}<br>
								<b>Місце розташування,&nbsp;км</b>:&nbsp;{{ dashIfUndefined(
								node.object?.passport?.get(Station.passportKeys.pipelineKm) ) }}<br>
							</p>
							<p class="card-text">
								<b>Тип контролю ПВ</b>:&nbsp;{{ dashIfUndefined(
								Post.postControlType[node.object?.passport?.get(Post.passportKeys.controlType)]?.title )
								}}
							</p>
							<button type="button" class="btn btn-sm btn-primary" @click="goToNodePassportSection(node)">
								Переглянути паспорт
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="row my-2">
				<!-- <input v-model.trim="edgeLableInput" /> -->
				<p class="fs-6 my-1">Підпис зв'язку</p>
				<div class="input-group dropup">
					<button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
						aria-expanded="false">
						Обрати
					</button>
					<ul class="dropdown-menu">
						<li v-for="n in [edgePopUp.sourceNode.object, edgePopUp.targetNode.object]" :key="n?.id">
							<button v-if="n?.passport?.get(ObjectPrototype.passportKeys.pipelineId)"
								class="dropdown-item btn btn-secondary"
								@click="edgeLableInput=pipelines(objectOrg(n)).find(el => el.id == n?.passport?.get(ObjectPrototype.passportKeys.pipelineId))?.title">
								{{ pipelines(objectOrg(n)).find(el => el.id ==
								n?.passport?.get(ObjectPrototype.passportKeys.pipelineId))?.title }}
							</button>
						</li>
					</ul>
					<input type="text" class="form-control" aria-label="Text input with dropdown button"
						v-model.trim="edgeLableInput">
					<button type="button" class="btn btn-sm btn-primary"
						@click="layoutEdges[makeEdgeId(edgePopUp.sourceNode.object.id, edgePopUp.targetNode.object.id)]={ label: edgeLableInput }; save('edge_names')">
						Зберегти
					</button>
				</div>
			</div>
		</template>
	</pop-up-modal>

	<!-- Save position confirmation popup -->
	<confirmation-popup :title="confirmationPopUp.title" confirmButtonTitle="Так" rejectButtonTitle="Ні"
		v-model:show="confirmationPopUp.show" @confirm="confirmationPopUp.onConfirm()">
		<template v-slot:body>
			<p :class="[confirmationPopUp.style]">
				{{ confirmationPopUp.textPromt }}
			</p>
		</template>
	</confirmation-popup>
</template>
	
	
<script>
import { useAccontStore } from '@/stores/AccountStore'
import { useStationsStore } from '@/stores/StationsStore'
import { usePostsStore } from '@/stores/PostsStore'
import * as vNG from "v-network-graph"
import { ForceLayout, } from "v-network-graph/lib/force-layout";
import PopUpModal from '../PopUpModal.vue'
import { ObjectPrototype } from "@/models/objectPrototype.js"
import { Post } from "@/models/post.js"
import { Station } from "@/models/station.js"
import { PowerUnit } from '@/models/powerUnit.js'
import { RESOURCE_NAMES, updateResourceItem, } from '@/api/api.js'
import ConfirmationPopup from '../ConfirmationPopup.vue'
import { fixNumberPrecision } from '@/helpers.js'


export default {
	inject: ['headerHeight', 'stationSvgPath', 'postSvgPath', ],

	buttonEdgeLen: "33px",
	GRAPH_OBJECT_NAME: 'relation_graph',

	components: {
		PopUpModal,
		ConfirmationPopup,
	},

	props: {
	},

	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()
		const postsStore = usePostsStore()
		const MIN_ZOOM = 0.1
		const MAX_ZOOM = 64
		const graphConfig = vNG.defineConfigs({
			view: {
				//autoPanAndZoomOnLoad: 'fit-content',
				scalingObjects: false,
				minZoomLevel: MIN_ZOOM,
				maxZoomLevel: MAX_ZOOM,
				autoPanOnResize: false,
				layoutHandler: new ForceLayout({
					positionFixedByDrag: false,
					positionFixedByClickWithAltKey: false,
					//noAutoRestartSimulation: true, // If the line is deleted or set to false,
					// d3-force recalculation will be performed when nodes are dragged or
					// the network changes.
					createSimulation: (d3, nodes, edges) => {
						const forceLink = d3
							.forceLink(edges)
							.id((d) => d.id);
						// Specify own d3-force parameters
						return d3
							.forceSimulation(nodes)
							.force("edge", forceLink.distance(500).strength(1))
							.force("charge", d3.forceManyBody().strength(-10000))
							.force("x", d3.forceX())
							.force("y", d3.forceY())
							//.stop() // tick manually
							.tick(1000);
					},
					
				}),
			},
			node: {
				label: {
					visible: true,
					direction: "south",
					directionAutoAdjustment: true,
					//color: "#5555FF",
				},
			},
			edge: {
				normal: {
					width: 3,
					// Load color from edge object
					color: edge => edge.color,
				},
				hover: {
					//color: "#3a0d66",
				},
			},
		})

		return {
			accountStore,
			stationsStore,
			postsStore,
			MIN_ZOOM,
			MAX_ZOOM,
			graphConfig,
			Station,
			Post,
			ObjectPrototype,
		}
	},

	data() {
		return {
			isLoaded: false,

			// Graph layout
			layout: {
				nodes: {},	// coordinates for nodes
			},
			layoutEdges: {},	// labels for edges
			zoomLevel: null,

			clickTimeout: null, // need for wait if double click

			// Edge settings popup context
			edgePopUp: {
				isShow: false,
				title: "",
				sourceNode: {},
				targetNode: {},
			},
			edgeLableInput: "",

			//
			confirmationPopUp: {
				show: false,
				style: 'text-danger',
				title: '',
				textPromt: '',
				onConfirm: () => {},
			},

			// For search input
			search: '',	// search phrase
			selectedNodeId: null,
		}
	},

	async created() {
		if (this.stationsStore.isNoStations) {
			// Read all stations
			await this.stationsStore.readStations()
			await this.stationsStore.readMetrics()
		}

		if (this.postsStore.isNoPosts) {
			// Read all posts
			await this.postsStore.readPosts()
			await this.postsStore.readMetrics()
		}

		// Read account (update schema layout)
		await this.accountStore.load()

		// The fixed position of the node can be specified.
		const savedLayuot = this.accountStore.organization[this.$options.GRAPH_OBJECT_NAME]
		let minX = 0
		let maxY = 0
		//debugger
		if (savedLayuot) {
			//this.layout.nodes = {...savedLayuot.nodes}
			// Nodes position is present
			if (savedLayuot.nodes) {
				//this.layout.nodes['test'] = { x: 0, y: 0, fixed: true }
				//console.log("nodes", savedLayuot.nodes)
				// Fix nodes position
				for (const [key, node] of Object.entries(savedLayuot.nodes)) {
					//node.fixed = true
					this.layout.nodes[key] = { x: node.x, y: node.y, fixed: true }
					minX = Math.min(node.x, minX)
					maxY = Math.max(node.y, maxY)
				}
			}

			// Set zoom
			//this.zoomLevel = savedLayuot.zoomLevel
			
			// Edges settings
			this.layoutEdges = { ...savedLayuot.edges }

			// Place non-fixed position nodes to bottom side of viewbox
			let nonFixedNodesCounter = 0
			for (const [key,] of Object.entries(this.nodes)) {
				if (this.layout.nodes[key] == undefined) {
					//console.log(key, value)
					this.layout.nodes[key] = {
						x: minX + 5 * nonFixedNodesCounter,
						y: maxY + 5,
						fixed: true
					}
					nonFixedNodesCounter++
					//this.layout.nodes[key] = { fixed: false }
				}
			}
		} else {
			// Add fixed position nodes to graph
			for (const [key,] of Object.entries(this.nodes)) {
				if (this.layout.nodes[key] == undefined) {
					this.layout.nodes[key] = { fixed: true }
				}
			}
		}
		
		this.isLoaded = true
	},

	mounted() {
		document.title = "Схема"
	},

	methods: {
		breakLongNames(name, breakAfter=16) {
			let temp = name

			// Insert line break if name too long
			for (let i = 0; i < temp.length; i++) {
				if (i > breakAfter && temp[i] === " ") {
					temp = temp.slice(0, i) + '\n' + temp.slice(i)
					break
				}
			}

			return temp
		},

		dashIfUndefined(value) {
			return value === undefined || value === null ? '-' : value
		},

		save(what, confirmed=false) {
			if (!confirmed) {
				// Show confirmation popup
				switch(what) {
					case 'layout':
						this.confirmationPopUp.title = 'Збереження позиції'
						this.confirmationPopUp.textPromt = 'Зберегти позиції станцій і КВП для усіх користувачів організації?'
						break
					case 'edge_names':
						this.confirmationPopUp.title = 'Збереження назви зв\'язку'
						this.confirmationPopUp.textPromt = 'Зберегти назву зв\'язку? Назва буде відображатись на схемі для всіх коритсувачів.'
						break
					default:
						return
				}
				this.confirmationPopUp.style = 'text-dark'
				this.confirmationPopUp.onConfirm = () => {
					this.save(what, true)
				}
				this.confirmationPopUp.show = true
				return
			}

			const payload = {}
			payload[this.$options.GRAPH_OBJECT_NAME] = {
				//nodes: {},
				//edges: {},
				//zoomLevel: this.zoomLevel,
				viewbox: this.$refs.graph?.getViewBox()
			}

			switch(what) {
				case 'layout': {
					let nodes = this.layout.nodes
					//delete nodes['test']
					payload[this.$options.GRAPH_OBJECT_NAME]['nodes'] = nodes
					break
				}
				case 'edge_names':
					payload[this.$options.GRAPH_OBJECT_NAME]['edges'] = this.layoutEdges
					break
				default:
					console.error("need to define what to save")
					return
			}

			// Request server to update account
			updateResourceItem(
				RESOURCE_NAMES.organizations,
				this.accountStore.userLogin,
				this.accountStore.userPassword,
				this.accountStore.organization._id,
				this.accountStore.organization._etag,
				payload
			).then(result => {
				//console.log("update account result = ", result)
				if (result._status == 'OK') {
					this.accountStore.organization._etag = result._etag
					this.accountStore.organization._updated = result._updated
				}
			}).catch(err => {
				console.error("on update graph layout", err)
			})
		},

		makeEdgeId(sourceNodeId, targetNodeId) {
			return `${sourceNodeId}->${targetNodeId}`
		},

		objectOrg(object) {
			return object?.passport?.get(Post.passportKeys.org)
		},

		pipelines(organization) {
			if (!organization) {
				return []
			}

			const pipelines = organization.pipelines
			if (!pipelines) {
				return []
			}

			return pipelines
		},

		goToNodeControlSection(node) {
			switch (node.type) {
				case "station":
					window.open(
						this.$router.resolve({ name: 'station_control', params: { id: `${node.object.id}` } }).href,
						'_blank'
					)
					break
				case "post":
					window.open(
						this.$router.resolve({ name: 'post_control', params: { id: `${node.object.id}` } }).href,
						'_blank'
					)
					break
			}
		},

		goToNodePassportSection(node) {
			switch (node.type) {
				case "station":
					window.open(
						this.$router.resolve({ name: 'station_passport', params: { id: `${node.object.id}` } }).href,
						'_blank'
					)
					break
				case "post":
					window.open(
						this.$router.resolve({ name: 'post_passport', params: { id: `${node.object.id}` } }).href,
						'_blank'
					)
					break
			}
		},

		potentialColor(potential) {
			if (potential < -3.5) {
				return '#f2495c'
			} else if (potential >=  -3.5 && potential < -2.5) {
				return '#ff9830'
			} else if (potential >=  -2.5 && potential < -0.85) {
				return '#5794f2'
			} else if (potential >=  -0.85) {
				return '#f2495c'
			} else {
				//return 'black'
				return "gray"
			}
		},

		nodeIconPath(nodeType) {
			switch(nodeType) {
				case 'station':
					return this.stationSvgPath
				case 'post':
					return this.postSvgPath
				default:
					return ''
			}
		},

		onSearchNodeInputChange(event) {
			this.selectedNodeId = event.target.value
			// Get node coordinates
			const node = this.layout.nodes[this.selectedNodeId]
			
			// If select node
			if (node) {
				this.isBlurGraph = true

				// Show node name in input
				this.search = this.nodes[this.selectedNodeId]?.name.trim()

				const sizes = this.$refs.graph.getSizes()
				this.$refs.graph?.panTo({ x: sizes.width / 2, y: sizes.height / 2 })
				

				// Zoom in target node
				const savedLayuot = this.accountStore.organization[this.$options.GRAPH_OBJECT_NAME]
				this.zoomLevel = savedLayuot?.zoomLevel ? savedLayuot.zoomLevel : this.zoomLevel

				// Need timeout for wait a fitToContents()
				setTimeout(() => {
					const sizes = this.$refs.graph.getSizes()
					const node = this.layout.nodes[this.selectedNodeId]
					
					// Translate node coordinates
					const nodeDomCoordinates = this.$refs.graph.translateFromSvgToDomCoordinates({ x: node.x, y: node.y })
			
					// Move viewbox to node coordinates (node on center)
					this.$refs.graph.panTo({
						x: (sizes.width - nodeDomCoordinates.x),
						y: (sizes.height - nodeDomCoordinates.y),
					})

					this.isBlurGraph = false
				}, 1)
			} else {
				this.selectedNodeId = null
			}
		},
	},

	computed: {
		/* Set all stations and posts as modes */
		nodes() {
			let stations = new Object()
			let posts = new Object()

			this.stationsStore.stationsArray.forEach(station => {
				if (!station.isActive)
					return

				let nodeName = station.shortName ? station.shortName : station.name
				nodeName = this.breakLongNames(nodeName)

				stations[station.id] = {
					name: '\xa0\n\xa0\n\xa0' + nodeName + '\xa0\n\xa0',
					type: "station",
					object: station,
					color: "Navy",
					potential: fixNumberPrecision(station.getMetric(PowerUnit.metricKeys.eOut)?.value),
				}
			});

			this.postsStore.postsArray.forEach(post => {
				if (!post.isActive)
					return

				let nodeName = post.shortName ? post.shortName : post.name
				nodeName = this.breakLongNames(nodeName)

				posts[post.id] = {
					name: '\xa0\n\xa0\n\xa0' + nodeName + '\xa0\n\xa0',
					type: "post",
					object: post,
					color: "CornflowerBlue",
					potential: fixNumberPrecision(post.getMetric(Post.metricsKeys.Eavg)?.value)
				}
			});

			return Object.assign(stations, posts,
				// { test: {
				// 	name: '\xa0\n\xa0\n\xa0' + 'zero' + '\xa0\n\xa0',
				// 	type: "station",
				// 	object: {},
				// 	color: "Navy",
				// 	potential: 555.5,
				// }}
			)
		},

		/* Set all relations as edges */
		edges() {
			let edges = new Object()
			let edgeId = 0

			// Station relations
			this.stationsStore.stationsArray.forEach(station => {
				const relations = station.passport.has(Station.passportKeys.relatedStations) ? station.passport.get(Station.passportKeys.relatedStations) : []
				
				relations.forEach(stationId => {
					edges[edgeId] = {
						type: 'station',
						source: stationId,
						target: station.id,
						color: '#0000806F',
					}

					// If label is present
					if (this.layoutEdges && this.layoutEdges[this.makeEdgeId(stationId, station.id)]) {
						// Add edge label
						edges[edgeId].label = this.layoutEdges[this.makeEdgeId(stationId, station.id)].label
					}

					edgeId++
				})
			});

			// Post relations
			this.postsStore.postsArray.forEach(post => {
				const relations = post.passport.has(Post.passportKeys.relatedStations) ? post.passport.get(Post.passportKeys.relatedStations) : []
				
				relations.forEach(postId => {
					edges[edgeId] = {
						type: 'post',
						source: postId,
						target: post.id,
						color: '#6495ED6F',
					}

					// If label is present
					if (this.layoutEdges && this.layoutEdges[this.makeEdgeId(postId, post.id)]) {
						// Add edge label
						edges[edgeId].label = this.layoutEdges[this.makeEdgeId(postId, post.id)].label
					}

					edgeId++
				})
			});

			//console.log('Edges', edges)

			return edges
		},

		eventHandlers() {
			return {
				"view:load": () => {
					//console.log('load graph')
					// Set viewbox
					const savedLayuot = this.accountStore.organization[this.$options.GRAPH_OBJECT_NAME]
					if (savedLayuot?.viewbox) {
						this.$refs.graph?.setViewBox(savedLayuot.viewbox)
					} else {
						this.$refs.graph?.fitToContents('8px')
						this.$refs.graph?.panToCenter()
					}
				},
				"node:dblclick": ({node}) => {
					//console.log("Click", node, this.nodes[node])
					clearTimeout(this.clickTimeout)
					this.clickTimeout = null // only clearTimeout don't work

					// Open object control section in new browser tab
					this.goToNodeControlSection(this.nodes[node])
				},

				"edge:dblclick": ({edge}) => {
					//console.log("Edge double click", edge, this.edges[edge], this.clickTimeout)
					clearTimeout(this.clickTimeout)
					this.clickTimeout = null // only clearTimeout don't work

					// Open object passport section in new browser tab
					switch (this.edges[edge].type) {
						case "station":
							window.open(
								this.$router.resolve({ name: 'station_passport', params: { id: `${this.edges[edge].target}` } }).href,
								'_blank'
							)
							break
						case "post":
							window.open(
								this.$router.resolve({ name: 'post_passport', params: { id: `${this.edges[edge].target}` } }).href,
								'_blank'
							)
							break
					}
				},

				"edge:click": ({edge}) => {
					//console.log("Edge click", edge, this.edges[edge])
					// Prepare modal popup data
					this.edgePopUp.sourceNode = this.nodes[this.edges[edge].source]
					this.edgePopUp.targetNode = this.nodes[this.edges[edge].target]
					this.edgePopUp.title = `Властивості зв'язку`
					//this.edgePopUp.isShow = true
					this.clickTimeout = setTimeout(() => { this.clickTimeout !== null ? this.edgePopUp.isShow = true : null }, 500)
					this.edgeLableInput = this.layoutEdges[this.makeEdgeId(this.edges[edge].source, this.edges[edge].target)]?.label
					//console.log("Layout", this.layout)
				},

				"node:dragend": (/*node*/) => {
					//
				},
			}
		},
	},

	beforeUnmount() {
	},
}
</script>


<style scoped>
.layout {
	box-sizing: border-box;
    display: block;
    float: none;
    position: relative;
    width: 100%;
    height: 100%;
}

.graph {
	/* border: 1px solid #000; */
}

.control-panel {
	position: absolute;
	z-index: 1000;
}

.btn-on-graph:hover svg path,
.btn-on-graph:hover svg rect {
  fill: #0a58ca
}
</style>